import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconLockProps extends SVGProps<any> {}
export class SVGIconLock extends Component<SVGIconLockProps> {
  render() {
    const { width = 24, height = 25, color = '#364856', ...rest } = this.props;
    return (
      <SVG
        style={{ zIndex: 12000 }}
        className="svg-icon-lock"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 75 120`}
        {...rest}
      >
        <g transform="translate(-303.88 -476.85)">
          <g>
            <path
              fill={color}
              d="m308.69 519.19s-1.5413-42.129 31.854-42.129 31.34 42.129 31.34 42.129h-8.7341s-0.25689-31.854-22.606-32.624c-22.349-0.77066-21.065 32.624-21.065 32.624h-10.789z"
            />
            <path
              fill={color}
              d="m377.72 556.96 0.0707-35.165h-36.735-36.735l-0.44306 35.165c0.0707 20.328 16.569 36.826 36.921 36.826s36.921-16.475 36.921-36.826z"
            />
          </g>
          <path
            fill={'white'}
            d="m340.79 538.92c-4.0128 0-7.2476 3.2348-7.2476 7.2476 0 2.9243 1.7057 5.4595 4.196 6.6119v18.087h6.898v-18.532c2.0532-1.2839 3.4331-3.5668 3.4331-6.1668 0-4.0128-3.2666-7.2476-7.2794-7.2476z"
          />
        </g>
      </SVG>
    );
  }
}
